<template src="./FavoriteButtonFloating.html" />
<script>
import FavoriteButtonHeart from '../../../Common/FavoriteButtonHeart.vue';
import IrFavoriteButtonHeartWithCount from './FavoriteButtonHeartWithCount.vue';

/**
 * 個別銘柄フローティングお気に入りボタンコンポーネント(IR用)
 * @vue-components {FavoriteButtonHeart} FavoriteButtonHeart お気に入りボタン
 * @module Stocks/IR/FavoriteButtonFloating
 * @property {String} financialItemCode 銘柄コード
 */
export default {
  name: 'IRFavoriteButtonFloating',
  components: {
    FavoriteButtonHeart,
    IrFavoriteButtonHeartWithCount,
  },
  props: {
    code: {
      type: String,
      default: '',
      required: true,
    },
    favoriteCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      financialItemCode: null,
    };
  },
  computed: {
    isFinancialItemFavored() {
      return this.financialItemCode
        ? this.$store.getters['favoriteFinancialItems/isFavored'](this.financialItemCode)
        : false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.favoriteButton) {
        this.financialItemCode = this.$refs.favoriteButton.financialItemCode;
      }
    });
  },
  methods: {
    /**
     * モーダルの表示
     */
    async open() {
      this.$store.commit('favoriteSignUpModal/show');
    },
  },
};
</script>
